/**
 * Centralized design-token map.
 *
 * ALL values point to CSS custom-properties defined in index.css.
 * To change a color across the entire app, update the CSS variable —
 * not this file.
 *
 * Groups:
 *   brand · text · background · border · status · overlay
 */
const colors = {
  /* ── Brand / Accent (Navy + Orange) ─────────────── */
  // Old theme colors (commented out):
  // themeColor:          "var(--brand-primary)",
  // purple:              "var(--brand-primary)",
  // blueColor:           "var(--brand-secondary)",
  // blueColorLight:      "var(--brand-secondary-subtle)",
  // gradient:            "var(--brand-gradient)",

  // New Theme Colors:
  themeColor:          "#1E3E62", // Navy
  purple:              "#1E3E62", // Navy (legacy mapping)
  blueColor:           "#FF6B00", // Orange
  blueColorLight:      "#FFF3E0", // Light Orange subtle
  gradient:            "linear-gradient(90deg, #1E3E62 0%, #FF6B00 100%)",
  navy:                "#1E3E62",
  orange:              "#FF6B00",
  amber:               "#FFC107",

  /* ── Text ───────────────────────────────────────── */
  mainTextColor:       "var(--text-primary)",
  h1Textcolor:         "var(--text-primary)",
  mainColor:           "var(--text-primary)",
  black:               "var(--text-primary)",
  fontBlack:           "var(--text-dark)",
  subTextColor:        "var(--text-secondary)",
  greyColor:           "var(--text-secondary)",
  dark:                "var(--text-secondary)",
  grey15:              "var(--text-secondary)",
  InputTextColor:      "var(--text-primary)",
  disabledTextColor:   "var(--text-muted)",
  gray:                "var(--text-muted)",

  /* ── Backgrounds ────────────────────────────────── */
  white:               "var(--bg-surface)",
  pureWhite:           "#ffffff",
  pureBlack:           "#000000",
  gray10:              "var(--bg-surface-2)",
  grey20:              "var(--bg-surface-2)",
  disabledColor:       "var(--bg-surface-3)",
  lightPurple:         "var(--bg-chip)",
  lightThemeColor:     "var(--bg-chip)",
  lightGreenColor:     "var(--bg-success-subtle)",
  lightDanger:         "var(--bg-danger-subtle)",
  bgOverlay:           "var(--bg-overlay)",

  /* ── Borders ────────────────────────────────────── */
  secondaryColor:      "var(--border-subtle)",
  borderColor:         "var(--border-subtle)",
  inputBorderColor:    "var(--border-light)",
  borderPurple:        "var(--border-brand)",
  borderBlue:          "var(--border-info)",
  borderGreen:         "var(--border-success)",

  /* ── Status: success ────────────────────────────── */
  success:             "var(--color-success)",
  greenColor:          "var(--color-success-dark)",
  lightGreen:          "var(--color-success-light)",
  lighGreen5:          "var(--color-success-subtle)",

  /* ── Status: danger / error ─────────────────────── */
  danger:              "var(--color-danger)",
  error:               "var(--color-danger-dark)",
  lightRed:            "var(--color-danger-border)",
  lightRed5:           "var(--color-danger-subtle)",
  lightRed2:           "var(--color-danger-subtle)",

  /* ── Status: warning / amber ────────────────────── */
  // yellow:              "var(--color-warning)",
  yellow:              "#FFC107",
  lightYellow:         "var(--color-warning-subtle)",
  lightYellow2:        "var(--color-warning-bg)",
  fundation:           "var(--color-warning-amber)",
  darkYellow:          "var(--color-warning-amber-dark)",
  gold:                "var(--color-gold)",

  /* ── Status: info / teal / cyan ─────────────────── */
  darkGreen:           "var(--color-teal)",
  green100:            "var(--color-info)",
  green5:              "var(--color-info-subtle)",
  foundationLightBlue: "var(--color-info-border)",
  infoBoxBg:           "var(--color-info-subtle)",
  foundationAtlasBlue: "var(--color-info-alt)",
  lightBlue:           "var(--color-info-light)",
};

export default colors;
